import { useLazyFetchShops } from '@@partner:graphql/query/shop/shops.gql'
import { commonFieldChange } from '@@partner:helpers/util'
import { GQL_ID } from '@@partner:types:graphql'
import AppLoader from '@components/common/AppLoader'
import React, { ReactNode, useState } from 'react'
import { CheckPicker, Form } from 'rsuite'
import { showSettingsType } from './ProductsTable'
import './ProductsTableShowSettings.scss'

const DEFAULT_STATE = {
  shopsIds: [],
  shops: []
}

type props = {
  onSelect: (value: showSettingsType) => void
}

export const renderLazyPickerMenu =
  (loading: boolean, data?: object) => (menu: ReactNode) => {
    if (loading || !data) {
      return (
        <div>
          <AppLoader.Inline content="Загружаем" />
        </div>
      )
    }

    return menu
  }


export default function ProductsTableShowSettings ({
  onSelect
}: props) {
  const [ state, setState ] = useState<showSettingsType>(DEFAULT_STATE)

  const [ fetchShops, { data, loading } ] = useLazyFetchShops()

  const handleFieldChange = commonFieldChange(setState)

  const handleShopsChange = (shopsIds: GQL_ID[]) => {
    setState((prevState) => ({
      ...prevState,
      shopsIds,
      shops: data?.shops.filter((shop) => shopsIds.includes(shop.id)) || []
    }))
  }

  const handleSubmit = () => {
    onSelect(state)
  }

  return (
    <Form
      formValue={state}
    >
      <Form.Group>
        <CheckPicker
          value={state.shopsIds}
          data={data?.shops ?? []}
          onOpen={fetchShops}
          searchable={true}
          placeholder="Показать остаток и цену в магазине"
          valueKey="id"
          labelKey="name"
          size="sm"
          style={{ maxWidth: 260 }}
          renderMenu={renderLazyPickerMenu(loading, data)}
          onChange={handleShopsChange}
          onExit={handleSubmit}
        />
      </Form.Group>
    </Form>
  )
}